module.exports = __webpack_public_path__ + "static/ART_Logo-usage_incorrect1-b0fced572dab97a3312b70d251e43c2f.svg";